module.exports = __webpack_public_path__ + "img/voice.4ae6bf2b.svg";